// (c) chaehongee. Confidential and proprietary.

// Tree layout spacing constants
export const TREE_LAYOUT_CONSTANTS = {
    NODESEP: 40,   // Horizontal separation
    RANKSEP: 50,   // Vertical separation
    EDGESEP: 20,   // Edge separation
    MARGIN: 20,    // Margin around the graph
    NODE_SIZE: 20, // Image node display size
} as const
